import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize(`${import.meta.env.VITE_FIREBASE_MEASUREMENT_ID}`);
};

export const logPageView = (path?: string) => {
  ReactGA.send({
    hitType: "pageview",
    page: path || window.location.pathname + window.location.search,
  });
};

export const logEvent = (category: string, action: string, label?: string) => {
  ReactGA.event({ category, action, label });
};

export const logEventRecord = (
  eventName: string,
  parameters?: Record<string, any>
) => {
  ReactGA.event(eventName, parameters);
};
